import { Component } from '@angular/core';
import { Project } from '../../models/project';
import { Widget, WidgetFilter, WidgetTemplate, WidgetTemplateFilter } from 'app/models/widget';
import { WidgetService } from '../widget.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalComponent } from '../../core/modal.component';
import { ActiveModal } from '../../core/modal.service';

@Component({
  selector: 'app-edit-widget-modal',
  templateUrl: './edit-widget-modal.component.html',
  styleUrls: ['./edit-widget-modal.component.scss']
})
export class EditWidgetModalComponent extends ModalComponent {
  form: FormGroup;
  selectedTemplate: WidgetTemplate;
  widget: Widget;
  availableTemplates: WidgetTemplate[];
  isSaving: boolean = false;
  settingsFormGroupCreated: boolean;
  filtersFormGroupCreated: boolean;

  constructor(private widgetService: WidgetService,
              public activeModal: ActiveModal,
              private fb: FormBuilder) {
    super(activeModal);
    this.createForm();
  }

  initCreate(project: Project) {
    this.widget = new Widget();
    this.widget.project = project;
    this.loadTemplates();
    this.slugifyOnNameChange();
    this.opened = true;
  }

  initEdit(widget: Widget) {
    this.widget = widget;
    this.selectedTemplate = this.widget.template;

    this.form.patchValue({
      name: this.widget.name,
      slug: this.widget.slug,
      status: this.widget.status,
      template: this.widget.template.id,
      settings: this.widget.settings
    });

    this.loadTemplates();
    this.opened = true;
  }

  save() {
    this.isSaving = true;

    this.updateModel();

    if (this.widget.id) {
      this.widgetService.update(this.widget).finally(() => this.isSaving = false).subscribe(widget => {
        this.activeModal.close(widget);
      });
    } else {
      this.widgetService.create(this.widget).finally(() => this.isSaving = false).subscribe(widget => {
        this.activeModal.close(widget);
      });
    }
  }

  isFilterActive(filter: WidgetTemplateFilter) {
    let idx = this.widget.filters.findIndex((f) => f.filter.id === filter.id);
    return idx > -1;
  }

  addFilter(filter: WidgetTemplateFilter) {
    const widgetFilter = new WidgetFilter();
    widgetFilter.filter = filter;
    this.widget.filters.push(widgetFilter);
  }

  removeFilter(filter: WidgetFilter) {
    let idx = this.widget.filters.findIndex((f) => f.filter.id === filter.filter.id);
    if (idx > -1) {
      this.widget.filters.splice(idx, 1);
    }
  }


  private loadTemplates() {
    return this.widgetService.getTemplatesForClient(this.widget.project.client).subscribe(templates => {
      this.availableTemplates = templates;

      if (this.widget.template && this.widget.template.id) {
        this.settingsFormGroupCreated = false;
        this.selectedTemplate = this.availableTemplates.find(template => {
          return template.id === this.widget.template.id;
        });
        this.form.setControl('settings', this.createSettingsFormGroup());
        this.form.setControl('filters', this.createFiltersFormGroup());
      }
    })
  }

  private updateModel() {
    const value = this.form.value;

    this.widget.template = this.selectedTemplate;
    this.widget.name = value.name;
    this.widget.status = value.status;
    this.widget.slug = value.slug;
    this.widget.settings = value.settings;
  }

  private slugifyOnNameChange() {
    this.form.get('name').valueChanges
      .debounceTime(300)
      .subscribe(name => {
        if (this.form.get('slug').dirty) {
          return false;
        }
        this.widgetService.getWidgetSlug(name).subscribe(slug => {
          this.form.get('slug').setValue(slug);
        });
      });
  }

  get noTemplatesError() {
    return this.availableTemplates && !this.availableTemplates.length;
  }

  private createSettingsFormGroup() {
    let controls = {};

    if (!this.selectedTemplate) {
      return this.fb.group({});
    }

    this.selectedTemplate.settings.forEach(setting => {
      const value = this.widget.settings ? this.widget.settings[setting.key] : null;
      controls[setting.key] = [value, null]
    });

    this.settingsFormGroupCreated = true;

    return this.fb.group(controls);
  }


  private createFiltersFormGroup() {
    let controls = {};

    if (!this.selectedTemplate) {
      return this.fb.group({});
    }

    console.log('apa', this.widget.filters);

    this.selectedTemplate.filters.forEach(filter => {
      const value = this.widget.filters.findIndex(f => f.id === filter.id);
      controls[filter.id] = [value, null]
    });

    this.filtersFormGroupCreated = true;

    return this.fb.group(controls);
  }

  get settingControls() {
    return this.form.get('settings');
  }

  private createForm() {
    this.form = this.fb.group({
      name: ['', Validators.required],
      slug: ['', Validators.required],
      status: ['', Validators.required],
      template: ['', Validators.required],
      settings: this.createSettingsFormGroup(),
      filters: this.createFiltersFormGroup()
    });

    this.form.get('template').valueChanges.subscribe(t => {
      if (!this.availableTemplates) {
        return;
      }

      this.selectedTemplate = this.availableTemplates.find(template => {
        return template.id === +t;
      });

      this.form.setControl('settings', this.createSettingsFormGroup());
      this.form.setControl('filters', this.createFiltersFormGroup());
    });
  }

  get availableStatuses() {
    return this.widgetService.availableStatuses;
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/edit-widget-modal/edit-widget-modal.component.ts